import {Base} from "@/api/Base"

export class GiEdit extends Base {
    path = "gi/edit"
}